'use client';

import { COUNTRIES } from '@/shared/constants/countries';
import { ControlledSelect } from '@/shared/ui/kit/controlled-select';
import { useFormContext, useWatch } from 'react-hook-form';
import { ClearableInput } from '@/shared/ui/kit/clearable-input';
import { BillingAddressFormData } from '@/shared/lib/validation/registration-wizard/billing-address';


export const BillingAddressFields = () => {
    const { register, control, formState: { errors }, setValue, clearErrors } = useFormContext<BillingAddressFormData>();
    const [
        billingEmail, billingEmailAdditional, vatId, billingPostalCode, , billingCity,
        billingAddress, billingAddressExtra,
    ] = useWatch({
        control,
        name: [
            'billing_email', 'billing_email_additional', 'vat_id', 'billing_postal_code', 'billing_country',
            'billing_city', 'billing_address', 'billing_address_extra',
        ],
    });

    return (
        <>
            <ClearableInput
                label="Billing e-mail"
                placeholder="mail@example.com"
                autoComplete="email"
                type="email"
                error={ errors.billing_email?.message }
                required
                value={ billingEmail }
                onClear={ () => setValue('billing_email', '', { shouldValidate: true }) }
                { ...register('billing_email') }
                onFocus={ () => clearErrors('billing_email') }
            />

            <ClearableInput
                label="Billing email (additional)"
                placeholder="mail@example.com"
                autoComplete="email"
                type="email"
                error={ errors.billing_email_additional?.message }
                value={ billingEmailAdditional ?? '' }
                onClear={ () => setValue('billing_email_additional', '', { shouldValidate: true }) }
                { ...register('billing_email_additional') }
                onFocus={ () => clearErrors('billing_email_additional') }
            />

            <ClearableInput
                label="VAT ID (optional)"
                placeholder="Enter VAT number"
                error={ errors.vat_id?.message }
                value={ vatId ?? '' }
                onClear={ () => setValue('vat_id', '', { shouldValidate: true }) }
                { ...register('vat_id') }
                onFocus={ () => clearErrors('vat_id') }
            />

            <ClearableInput
                label="Postal code"
                placeholder="Enter postal code"
                autoComplete="postal-code"
                error={ errors.billing_postal_code?.message }
                required
                value={ billingPostalCode }
                onClear={ () => setValue('billing_postal_code', '', { shouldValidate: true }) }
                { ...register('billing_postal_code') }
                onFocus={ () => clearErrors('billing_postal_code') }
            />

            <ControlledSelect
                name="billing_country"
                label="Country"
                options={ COUNTRIES }
                placeholder="Select country"
                searchable
                required
            />

            <ClearableInput
                label="City"
                placeholder="Enter city"
                autoComplete="address-level2"
                error={ errors.billing_city?.message }
                required
                value={ billingCity }
                onClear={ () => setValue('billing_city', '', { shouldValidate: true }) }
                { ...register('billing_city') }
                onFocus={ () => clearErrors('billing_city') }
            />

            <ClearableInput
                label="Billing address"
                placeholder="Enter billing address"
                autoComplete="street-address"
                error={ errors.billing_address?.message }
                required
                value={ billingAddress }
                onClear={ () => setValue('billing_address', '', { shouldValidate: true }) }
                { ...register('billing_address') }
                onFocus={ () => clearErrors('billing_address') }
            />

            <ClearableInput
                label="Additional address information"
                placeholder="Apartment, floor, etc."
                error={ errors.billing_address_extra?.message }
                value={ billingAddressExtra ?? '' }
                onClear={ () => setValue('billing_address_extra', '', { shouldValidate: true }) }
                { ...register('billing_address_extra') }
                onFocus={ () => clearErrors('billing_address_extra') }
            />
        </>
    );
};
